import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import "./StoreSelector.scss"
import { useFormContext } from "react-hook-form";
import CustomTips from "components/base/CustomTips";
import BaseSearchBar from "components/base/BaseSearchBar";
import { CustomTitleWithDropDown } from "components/customer/CustomTitleWithDropDown";
import { createAction } from "utils";
import { Checkbox } from "antd";
import PerfectScrollbar from 'react-perfect-scrollbar';
import BasePrompt from "components/base/prompt/BasePrompt";
import Loading from "components/base/Loading";
import GroupedStoresDisplaySection from "./GroupedStoresDisplaySection";
import { ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";
import { ProcessEnvConfig } from "config/ProcessEnvConfig";


const mapPropsToState = (state) => ({
  customerList: state.customerList.customerList,
  brandList: state.brand.brandList,
  allCategoryList: state.storeCategoryList.allCategoryList,
  couponStores: state.storeModel.couponStores,
  isLoadingStore: state.storeModel.allListLoading,
  mallList: state.mall.mallList,
});

const StoreSelector = ({
  fieldNamePrefix,
  storesFieldName = "selectedStores",
  brandList,
  allCategoryList,
  mallList,
  couponStores,
  isLoadingStore,
}) => {
  const dispatch = useDispatch();
  const allStores = couponStores?.stores || [];
  const [originCouponStores, setOriginCouponStores] = useState({});
  const initCouponStores = useRef()

  const {
    watch,
    setValue,
    formState: { errors }
  } = useFormContext();
  const [storeSearch, setStoreSearch] = useState();
  const [filteredCategory, setFilteredCategory] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredMall, setFilteredMall] = useState([]);

  const [selectedStorePks, setSelectedStorePks] = useState([]);
  const [showStoreSelectorModal, setShowStoreSelectorModal] = useState(false);

  const truelyStoreFieldName = fieldNamePrefix ? `${fieldNamePrefix}${storesFieldName}` : storesFieldName;
  const formSelectedStores = watch(truelyStoreFieldName) || [];
  // const selectedStoreIds = formSelectedStores?.map(item=> item?.id);

  const [indeterminate, isSelectAllStore] = useMemo(() => {
    const allStorePks = allStores?.map(item => item?.pk || item?.id)
    if (!allStorePks > 0 || !selectedStorePks > 0) {
      return [false, false]
    }
    const validSelectedStorePks = selectedStorePks?.filter(id => allStorePks?.includes(id))
    if (validSelectedStorePks?.length > 0) {
      return [
        validSelectedStorePks?.length !== allStorePks?.length,
        validSelectedStorePks?.length === allStorePks?.length,
      ]
    }
    return [false, false]
  }, [allStores, selectedStorePks])
  const closeModal = () => setShowStoreSelectorModal(false);

  const clearSearchAndFilter= ()=>{
    setStoreSearch("")
    setFilteredCategory([])
    setFilteredBrands([])
    setFilteredMall([])
  }
  const selectAllStores = () => {
    if (allStores?.length> 0) {
      setSelectedStorePks(allStores?.map(store => store?.pk || store?.id))
    }
  }
  const clearSelectedStores = () => {
    setSelectedStorePks([])
  }
  const onCheckAllStores = (e) => {
    const checked = e.target.checked
    if (checked) {
      selectAllStores()
    } else {
      clearSelectedStores()
    }
  }

  const onCheckSingleStore = (checked, store) => {
    if (checked) {
      setSelectedStorePks(prevState => [...prevState, store?.pk || store?.id])
      return
    }
    setSelectedStorePks(prevState => prevState?.filter(item => item !== (store?.pk ||store?.id)) || [])
  }

  const removeFormStore = (removeId) => {
    setValue(truelyStoreFieldName, formSelectedStores?.filter(item => (item?.pk ||item?.id) !== removeId), { shouldDirty: true })
  }

  const queryStores = ()=> {
    dispatch(createAction('storeModel/getAllCouponStores')({
      searchIdOrName: storeSearch ? storeSearch : null,
      brandIds: filteredBrands?.length > 0 ? filteredBrands?.map(item => item?.value?.pk) : null,
      mallIds: filteredMall?.length > 0 ? filteredMall?.map(item => item?.value?.pk) : null,
      storeCategoryIds: filteredCategory?.length > 0 ? filteredCategory?.map(item => item?.value?.pk) : null,
    }))
  }
  const onConfirm = ()=> {
    setOriginCouponStores(couponStores)
    setValue(truelyStoreFieldName, allStores?.filter(item => selectedStorePks?.includes(item?.pk || item?.id)), { shouldDirty: true })
  }

  useEffect(()=>{
    const filter = setTimeout(() => {
      queryStores()
    }, 500);
    return () => {
      clearTimeout(filter);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSearch, filteredBrands, filteredCategory, filteredMall]);

  useEffect(()=>{
    if (formSelectedStores?.length > 0) {
      setSelectedStorePks(formSelectedStores?.map(item => item?.pk ||item?.id))
      return
    }
    setSelectedStorePks([])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formSelectedStores?.length])

  useEffect(()=>{
    if (couponStores && !initCouponStores.current) {
      initCouponStores.current=true
      
      setOriginCouponStores(couponStores)
    }
  }, [couponStores])

  return <div className="store-selector-with-summary-container">
    <button
      className="custom-upload-btn"
      style={{width: "fit-content"}}
      onClick={() => {
        setShowStoreSelectorModal(true)
      }}
    >
      {"Select stores"}
    </button>
    <ReactHookFormErrorMessage errors={errors} id={truelyStoreFieldName} />
    <GroupedStoresDisplaySection
      allSelectedStores={formSelectedStores}
      allGroupedCouponStores={originCouponStores}
      removeOneStoreAction={removeFormStore}
      removeGroupedStoreAction={(condition) => {
        const { type } = condition
        const { id: conditionID, stores } = condition?.obj
        if (type === "store") {
          removeFormStore(conditionID)
          return;
        }
        if (stores?.length > 0) {
          const removeStoreIds = stores?.map(store => store?.pk ||store?.id) || []
          setValue(truelyStoreFieldName, formSelectedStores?.filter(item => !removeStoreIds?.includes(item?.pk || item?.id)), { shouldDirty: true })
        }
      }}
    />
    <BasePrompt
      show={showStoreSelectorModal}
      closeAction={closeModal}
      backdrop="static"
      leftButton={{
        text: "Cancel",
        action: closeModal,
      }}
      rightButton={{
        text: "Confirm to Add",
        action: ()=>{
          onConfirm()
          closeModal()
        },
      }}
      customClass={"store-selector-modal"}
      title={"Select store"}
      otherBody={()=> 
        <div className="modal-store-selector-container">
          <div className="modal-store-selector-info">
            <div>{`You have selected ${selectedStorePks?.length || 0} stores`}</div>
            <div className="clear-all-button">
              <div onClick={() => {
                clearSearchAndFilter()
                clearSelectedStores()
              }}>{"Clear all"}</div>
              <CustomTips
                detail={
                  'If click Clear all, will clear all filter, search, and selected store'
                }
                placement="bottom"
              />
            </div>
          </div>
          <div className="store-selector-section">
            {ProcessEnvConfig.haveShopMall ?
              <div className="store-selector-filter-bar" style={{ justifyContent: "flex-end" }}>
                <div />
                <div />
                <BaseSearchBar value={storeSearch} setValue={setStoreSearch} />
              </div> : null
            }
            <div className="store-selector-filter-bar">
              {ProcessEnvConfig.haveShopMall ? null : <BaseSearchBar value={storeSearch} setValue={setStoreSearch} />}
            <CustomTitleWithDropDown
                displaySelectAllAsItem={true}
                onSelectAll={(selected) => {
                }}
                placeholder={"Filter by store category"}
                dropDownSearchBarPlaceholder={"Search by name"}
                alwaysHint={
                  filteredCategory?.length > 0 && `Filter by store category (${filteredCategory?.length})`
                }
                customClass={"no-margin"}
                defaultValue={filteredCategory}
                setValue={setFilteredCategory}
                source={allCategoryList}
                hasAddButton={false}
                labelContainPk={true}
                filterAction={'storeCategoryList/getStoreCategoryList'}
                loadMoreAction={'storeCategoryList/getStoreCategoryList'}
                defaultFilter={{
                  moreSearch: {
                    sort: "-pk"
                  }
                }}
                multiple={true}
                hideDeleteButton={true}
                displaySeletcAll
              />
              <CustomTitleWithDropDown
                placeholder={"Filter by brand"}
                dropDownSearchBarPlaceholder={"Search by name"}
                alwaysHint={
                  filteredBrands?.length > 0 && `Filter by brand (${filteredBrands?.length})`
                }
                customClass={"no-margin"}
                defaultValue={filteredBrands}
                setValue={setFilteredBrands}
                source={brandList}
                hasAddButton={false}
                labelContainPk={true}
                loadMoreAction={'brand/getCurrentPageBrands'}
                filterAction={'brand/getCurrentPageBrands'}
                multiple={true}
                hideDeleteButton={true}
                defaultFilter={{
                  isSimpleNode: true
                }}
              />
              {ProcessEnvConfig.haveShopMall ? 
                <CustomTitleWithDropDown
                  displaySelectAllAsItem={true}
                  onSelectAll={(selected) => {
                  }}
                  placeholder={"Filter by mall"}
                  dropDownSearchBarPlaceholder={"Search by name"}
                  alwaysHint={
                    filteredMall?.length > 0 && `Filter by mall (${filteredMall?.length})`
                  }
                  customClass={"no-margin"}
                  defaultValue={filteredMall}
                  setValue={setFilteredMall}
                  source={mallList}
                  hasAddButton={false}
                  labelContainPk={false}
                  filterAction={'mall/getPagedMallList'}
                  loadMoreAction={'mall/getPagedMallList'}
                  multiple={true}
                  hideDeleteButton={true}
                  displaySeletcAll
                /> : null}
            </div>
            <div className="split-solid-line" />
            <Checkbox
              indeterminate={isLoadingStore ? false : indeterminate}
              onChange={onCheckAllStores}
              checked={isLoadingStore ? false : isSelectAllStore}
            >
              All
            </Checkbox>
            <div className="split-dashed-line" />
            <PerfectScrollbar className="store-checkable-list-container">
              {isLoadingStore ? <Loading /> : 
                allStores?.map(store =>
                  <Checkbox
                    onChange={(e) => {
                      const checked = e.target.checked
                      onCheckSingleStore(checked, store)
                    }}
                    checked={selectedStorePks?.includes(store?.pk || store?.id)}
                  >
                    {`[ID: ${store?.pk || store?.id || '-'}] ${store?.name || "-"}`}
                  </Checkbox>
                )?.reverse()
              }
            </PerfectScrollbar>
          </div>
        </div>
      }
    />
  </div>
}


export default connect(mapPropsToState)(StoreSelector);